import { createReducer, on } from '@ngrx/store';
import { RoleActions } from './role.actions';
import { IRole } from '../../models/role.model';

export interface RoleState {
  roles: IRole[];
  loading: boolean;
  error: string | null;
  role: IRole | undefined; // Optional for single role retrieval
}

export const initialRoleState: RoleState = {
  roles: [],
  loading: false,
  error: null,
  role: undefined, // Initialize as undefined for single role
};

export const roleReducer = createReducer(
  initialRoleState,

  on(RoleActions.listSystemRoles, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(RoleActions.listSystemRolesSuccess, (state, response ) => ({
    ...state,
    roles: response.data,
    loading: false,
    error: null,
  })),

  on(RoleActions.listSystemRolesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(RoleActions.getSingleRole, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(RoleActions.getSingleRoleSuccess, (state, { data }) => ({
    ...state,
    role: data,
    loading: false,
    error: null,
  })),
  on(RoleActions.getSingleRoleFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);
